import { InitBlocsAction } from './blocks'
import { InitColorsAction } from './colors'
import { InitEstimatesAction } from './estimates'
import { InitNodesActions } from './nodes'
import { InitSectionsAction } from './sections'
import { InitSettingsAction } from './settings'
import { InitTabAction } from './tabs'
import { InitTagsAction } from './tags'

export const InitProjectActions = [
  InitColorsAction,
  InitSettingsAction,
  InitTagsAction,
  InitTabAction,
  InitSectionsAction,
  ...InitNodesActions,
  InitBlocsAction,
  InitEstimatesAction,
]
